import React, {useEffect, useState} from 'react';
import {Formik, Form, Field} from 'formik';
import {useUser} from "../../../contexts/UserContext";
import styles from "../../../pages/Admin/Admin.module.css";
import AxiosConfig from "../../../services/AxiosConfig";
import {useModal} from "../../../contexts/ModalContext";
import {Link, useNavigate} from "react-router-dom";
import TitleSecondary from "../../Title/TitleSecondary";
import SearchUtilisateur from "../../Search/SearchUtilisateur";
import FieldCheckbox from "../../Field/FieldCheckbox";
import stylesField from "../../Field/Field.module.css";
import BtnSave from "../../Button/BtnSave";
import {ReactComponent as AnnulerIcone} from "../../../icons/annuler.svg";

function ParticipantCreation({ activite = null, contrat = null, entreprise = null, seance = null, asu = null, onSuccess = null }) {
    const {showModal, hideModal} = useModal();
    const formikRef = React.useRef();
    const [utilisateur, setUtilisateur] = useState(null);
    let navigate = useNavigate();

    const initialValues = {
        valid_presence: asu ? asu.valid_presence : false,
        desactiver: asu ? !asu?.actif : false,
        status: asu?.status ?? 1,
        show_modal_rating: asu ? !asu?.show_modal_rating : true,
    };

    const handleSuccess = (children = "Enregistré avec succès") => {
        showModal('success', {children: children, timeout: 5000});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 5000});
    };

    const handleSubmit = async (values, {setSubmitting}) => {
        values.utilisateur = utilisateur ? utilisateur : null;
        values.asu_id = asu && asu.id ? asu.id : null;

        console.log("seance", seance);

        try {
            const response = await AxiosConfig.post(`/admin/entreprises/${entreprise.id}/contrats/${contrat.id}/activites/${activite.id}/seances/${seance.id}/participations/creation`, values);
            if (response.data.success) {
                handleSuccess(response.data.message);
                if (onSuccess) {
                    onSuccess({seance: seance.id, nb: (values.desactiver === true ? 0 : 1), asuId: response.data.asu});
                    handleSuccess("Enregistré avec succès");
                } else {
                    navigate(`/admin/entreprises/${entreprise.id}/contrats/${contrat.id}/activites/${activite.id}/seances/${seance.id}/participations/${response.data.asu}`);
                }
            } else {
                handleError(response.data.error ?? response.data.message);
            }
        } catch (error) {
            console.error(error);
            handleError(error.message);
        } finally {
            setSubmitting(false);
        }
    };

    const submitUtilisateur = (values) => {
        setUtilisateur(values.email);
    }

    useEffect(() => {
        if (asu && asu.participant) {
            setUtilisateur(asu.participant.email);
        }
    }, [asu]);

    return (
        <div style={{margin: '0 0 50px 0'}} className={styles.viewBloc}>
            <TitleSecondary text={asu ? "Modifier" : "Nouvelle participation"}/>

            <div className={styles.formBloc}>
                <h3>Participant </h3>
                <SearchUtilisateur onSubmit={submitUtilisateur} entrepriseId={entreprise.id}/>
                <span style={{marginTop: "10px", color: "#74a61d", fontSize: "var(--fs-secondary)", fontStyle: "italic"}}>{utilisateur ?? "Pas d'utilisateur sélectionné"}</span>
            </div>

            {Object.keys(initialValues).length > 0 ? (
                <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize innerRef={formikRef}>
                    {({isSubmitting, setFieldValue}) => {
                        return (
                            <Form className={styles.form}>
                                <div className={styles.formBloc}>
                                    <FieldCheckbox name={"valid_presence"} label={"Valider présence"}/>
                                    <FieldCheckbox name={"show_modal_rating"} label={"Afficher la popup demandant de noter la dernière séance"}/>

                                    <div className={stylesField.select}>
                                        <span>Statut</span>
                                        <Field as="select" name="status">
                                            <option>
                                                -- Sélectionnez un statut --
                                            </option>
                                            <option value={"-1"}>
                                                pas_enregistre
                                            </option>
                                            <option value={"0"}>
                                                file_attente
                                            </option>
                                            <option value={"-2"}>
                                                file_attente_non_prio
                                            </option>
                                            <option value={"1"}>
                                                valide
                                            </option>
                                            <option value={"2"}>
                                                annule_utilisateur
                                            </option>
                                            <option value={"3"}>
                                                refuse
                                            </option>
                                        </Field>
                                    </div>

                                    <div style={{ display: "none" }}>
                                        <FieldCheckbox name={"desactiver"} label={"supprimer cette participation"}/>
                                    </div>
                                </div>

                                <div className={"barre_btn"}>
                                    <button type={"button"} onClick={() => {
                                        navigate(-1)
                                    }} className={"btn btn_danger"}><AnnulerIcone/>Annuler
                                    </button>
                                    <BtnSave isSubmitting={isSubmitting}/>
                                </div>
                            </Form>
                        )
                    }
                    }
                </Formik>
            ) : (<p>Chargement...</p>)}
        </div>);
}

export default ParticipantCreation;